import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-cas-component',
  templateUrl: './cas.component.html',
  styleUrls: ['./cas.component.scss'],
})
export class CasComponent implements OnInit {
  loadingText: string;

  constructor(private apiService: ApiService) {
    this.loadingText = 'testing...';
  }

  ngOnInit() {
    this.apiService.redirectToCastLogin().subscribe(
      (data) => {
        this.loadingText = data.url;
        if (data.url.startsWith('https://bibliotecapais.ceibal.edu.uy')) {
          window.location.href = 'https://bibliotecapais.ceibal.edu.uy/opac/authCAS?app=opac';
        }
      },
      (err) => {
        console.log(err);
        window.location.href = 'https://bibliotecapais.ceibal.edu.uy/opac/authCAS?app=opac';
      }
    );
  }
}
